import { useState } from "react";
import CTAButtons from "./CTAButtons";

export default function ManchesterFinalCTA({ config }) {
  const cityName = config?.cityName || "Manchester";
  const [showFallback, setShowFallback] = useState(false);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleFallback = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
  };

  return (
    <section style={{ backgroundColor: "#112215", padding: "clamp(64px,8vw,110px) clamp(20px,5vw,80px)", borderRadius: "24px 24px 0 0" }}>
      <div style={{ maxWidth: 760, margin: "0 auto", textAlign: "center" }}>
        <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px,4vw,44px)", letterSpacing: "-0.02em", lineHeight: 1.15, color: "#F4F1E7", margin: "0 0 20px" }}>
          Your {cityName} property, fully handled. From 12% + VAT.
        </h2>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 17, color: "rgba(255,255,255,0.7)", lineHeight: 1.65, margin: "0 0 16px" }}>
          Postcode and number of bedrooms is all we need to start. We come back with a figure built from live comparables in your area, plus the full breakdown of what reaches your account.
        </p>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, fontWeight: 600, color: "#CCF5AC", margin: "0 0 36px", lineHeight: 1.5 }}>
          No long lock-in. Cancel with 30 days' notice. Transparent fees, nothing hidden.
        </p>

        <div style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
          <CTAButtons dark includeMicrocopy />
        </div>

        {/* Low-commitment fallback */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: 32 }}>
          {!showFallback && !submitted && (
            <button
              onClick={() => setShowFallback(true)}
              style={{
                background: "none",
                border: "none",
                color: "rgba(255,255,255,0.6)",
                fontFamily: "'Inter', sans-serif",
                fontSize: 14,
                fontWeight: 500,
                cursor: "pointer",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                textDecorationThickness: "1px",
              }}
            >
              Not ready yet? Get the {cityName} landlord guide
            </button>
          )}
          {showFallback && !submitted && (
            <form onSubmit={handleFallback} style={{ display: "flex", gap: 10, maxWidth: 440, margin: "0 auto", flexWrap: "wrap", justifyContent: "center" }}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                style={{
                  flex: "1 1 240px",
                  border: "1px solid rgba(255,255,255,0.2)",
                  borderRadius: 8,
                  padding: "13px 18px",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 14,
                  color: "#F4F1E7",
                  background: "rgba(255,255,255,0.05)",
                  outline: "none",
                  minWidth: 0,
                  boxSizing: "border-box",
                }}
              />
              <button
                type="submit"
                style={{
                  background: "rgba(255,255,255,0.12)",
                  color: "#F4F1E7",
                  border: "1px solid rgba(255,255,255,0.25)",
                  borderRadius: 8,
                  padding: "13px 24px",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Send guide
              </button>
            </form>
          )}
          {submitted && (
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.7)", margin: 0 }}>
              Thanks. We'll send the guide to your inbox shortly.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}